import { modal } from './modules/modal';
import { smooth } from './modules/smooth';
import { bnrAction } from './modules/bnr';
import { slider } from './modules/slider';
import { tableScroll } from './modules/tableScroll';

modal();
smooth();
bnrAction();
slider();
tableScroll();
